"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var getRoutes = function (route, parent) {
    var routes = [];
    var _a = route.props || { path: '/undefined' }, path = _a.path, rest = __rest(_a, ["path"]);
    var routePath = path;
    if (parent) {
        routePath = "" + parent.path + route.path;
    }
    if (route.children) {
        route.children.forEach(function (child) {
            var childRoute = {
                name: child.name,
                component: child.routeProps.component,
                path: child.routeProps.path,
                props: child.routeProps,
                children: child.children,
            };
            var parentRoute = {
                path: routePath,
            };
            routes.push.apply(routes, getRoutes(childRoute, parentRoute));
        });
    }
    if (route.component) {
        routes.push(react_1.default.createElement(react_router_dom_1.Route, __assign({ key: route.name }, rest, { path: routePath })));
    }
    return routes;
};
var getPageRoutes = function (pages) {
    var routes = [];
    pages.forEach(function (page) {
        var rootRoute = {
            name: page.name,
            component: page.routeProps.component,
            props: page.routeProps,
            path: page.routeProps.path,
            children: page.children,
        };
        var pageRoutes = getRoutes(rootRoute);
        pageRoutes.forEach(function (pr) { return routes.push(pr); });
    });
    return routes;
};
exports.default = getPageRoutes;
//# sourceMappingURL=appRoutes.js.map